import { useContext } from 'react';

import {
  getApplicationsRequest,
  createApplicationRequest,
  updateApplicationRequest,
  deleteApplicationRequest,
  getUsersByRoleRequest,
  getApplicationRolesRequest,
  getApplicationPermissionsRequest,
} from 'utils/request/applications';

import { ApplicationContext } from './index';
import * as actions from './actions';

import { sortAppsByName } from 'utils/accessManagement';

let appDispatch;

// ============ v2 functions ============

async function getApplications() {
  try {
    appDispatch(actions.getApplications.request());

    const response = await getApplicationsRequest();
    const list = Array.isArray(response) ? response : response?.items ?? response?.applications ?? [];
    appDispatch(actions.getApplications.success(sortAppsByName(list)));
  } catch (error) {
    appDispatch(actions.getApplications.failure(error));
  }
}

async function createApplication({ gbmPodId, clientId, app, displayName, type }) {
  try {
    appDispatch(actions.createApplication.request());

    await createApplicationRequest({ gbmPodId, clientId, app, displayName, type });

    appDispatch(actions.createApplication.success());
  } catch (error) {
    appDispatch(actions.createApplication.failure(error));
  }
}

async function updateApplication(id, { displayName }) {
  try {
    appDispatch(actions.updateApplication.request());

    await updateApplicationRequest(id, { displayName });

    appDispatch(actions.updateApplication.success());
  } catch (error) {
    appDispatch(actions.updateApplication.failure(error));
  }
}

async function deleteApplication(id) {
  try {
    appDispatch(actions.deleteApplication.request());

    await deleteApplicationRequest(id);

    appDispatch(actions.deleteApplication.success());
  } catch (error) {
    appDispatch(actions.deleteApplication.failure(error));
  }
}

async function getUsersByRole(applicationId, role) {
  try {
    appDispatch(actions.getUsersByRole.request());

    const response = await getUsersByRoleRequest(applicationId, role);

    appDispatch(actions.getUsersByRole.success(response));
  } catch (error) {
    appDispatch(actions.getUsersByRole.failure(error));
  }
}

async function getApplicationRoles(applicationId) {
  try {
    appDispatch(actions.getApplicationRoles.request());

    const response = await getApplicationRolesRequest(applicationId);

    appDispatch(actions.getApplicationRoles.success(response));
  } catch (error) {
    appDispatch(actions.getApplicationRoles.failure(error));
  }
}

async function getApplicationPermissions(applicationId) {
  try {
    appDispatch(actions.getApplicationPermissions.request());

    const response = await getApplicationPermissionsRequest(applicationId);

    appDispatch(actions.getApplicationPermissions.success(response));
  } catch (error) {
    appDispatch(actions.getApplicationPermissions.failure(error));
  }
}

// ============ UI functions ============

async function selectedApplication(app) {
  try {
    appDispatch(actions.selectedApplication.success(app));
  } catch (error) {
    appDispatch(actions.selectedApplication.failure(error));
  }
}

function resetCreateApplication() {
  appDispatch(actions.createApplication.reset());
}

function resetUpdateApplication() {
  appDispatch(actions.updateApplication.reset());
}

function resetDeleteApplication() {
  appDispatch(actions.deleteApplication.reset());
}

function resetGetUsersByRole() {
  appDispatch(actions.getUsersByRole.reset());
}

function resetGetApplicationRoles() {
  appDispatch(actions.getApplicationRoles.reset());
}

function resetGetApplicationPermissions() {
  appDispatch(actions.getApplicationPermissions.reset());
}

function resetSelectedApplication() {
  appDispatch(actions.selectedApplication.reset());
}

export function useDispatcherApplication() {
  const { dispatch } = useContext(ApplicationContext);
  appDispatch = dispatch;

  return {
    // v2
    getApplications,
    createApplication,
    updateApplication,
    deleteApplication,
    getUsersByRole,
    getApplicationRoles,
    getApplicationPermissions,
    // UI
    selectedApplication,
    resetCreateApplication,
    resetUpdateApplication,
    resetDeleteApplication,
    resetGetUsersByRole,
    resetGetApplicationRoles,
    resetGetApplicationPermissions,
    resetSelectedApplication,
  };
}
